import { backOff } from 'exponential-backoff'
import spreadStrapiData from './spreadStrapiData'

/**
 * Fetches data for a specified Strapi content type.
 *
 * @param {string} contentType - The type of content to fetch from Strapi.
 * @param {string} params - Query parameters to append to the API request.
 * @param {boolean} spreadData - Determines whether to spread the data using spreadStrapiData function.
 * @return {Promise<object>} The fetched data, spread or as-is based on spreadData flag.
 */

export default async function fetchContentType(
  contentType,
  params,
  spreadData = true
) {
  return backOff(async () => {
    // Construct the full URL for the API request
    const url = new URL(`api/${contentType}`, process.env.API_URL)

    // Perform the fetch request with the provided query parameters
    const response = await fetch(`${url.href}?${params}`)


    if (!response.ok) {
      throw new Error(`Failed to fetch data from Strapi (url=${url.toString()}, query=${params} ,status=${response.status})`)
    }

    const jsonData = await response.json()

    // Return the JSON data, optionally spread using spreadStrapiData
    return spreadData ? spreadStrapiData(jsonData) : jsonData
  }, {
    retry: (e, attempt) => {
      console.log(`Retrying fetchContentType for ${contentType} with params ${params} for the ${attempt} time: ${e.toString()}`)

      return true;
    }
  })
}
